const theme = {
  colors: {
    // Mid-Century Modern color palette per specification
    primary: '#36454F',          // dark warm grey - primary text
    secondary: '#008080',        // teal - buttons, headlines, accents
    accent: '#FFDB58',           // mustard yellow - calls-to-action
    accent1: '#CC5500',          // burnt orange - accent highlights (alias for tertiary)
    accent2: '#D4A017',          // golden yellow - light accent
    accent3: '#5D8B3A',          // warm green - success accent
    tertiary: '#CC5500',         // burnt orange - accent highlights
    
    // Warm, premium base colors
    background: '#F5F5DC',       // off-white/beige - warm archival feel
    surface: '#FFFFFF',          // pure white for cards and sections
    surfaceAlt: '#F8F6F0',       // warm cream - subtle contrast
    cardBackground: '#FEFCF7',   // slightly warmer white for cards
    
    // Refined text colors
    text: '#36454F',             // dark warm grey - softer than pure black
    textSecondary: '#666666',    // medium gray - secondary text (alias for textMuted)
    textMuted: '#666666',        // medium gray - secondary text
    textLight: '#888888',        // light gray - subtle text
    primaryLight: '#E8E8E8',    // light version of primary for backgrounds
    
    // Utility colors with warm tones
    success: '#5D8B3A',          // warm green
    warning: '#D4A017',          // golden yellow
    error: '#B8563A',            // warm red
    
    // Subtle gradients for visual interest
    gradients: {
      primary: 'linear-gradient(135deg, #008080 0%, #36454F 100%)',
      secondary: 'linear-gradient(135deg, #FFDB58 0%, #CC5500 100%)',
      warm: 'linear-gradient(135deg, #F5F5DC 0%, #F8F6F0 100%)',
      card: 'linear-gradient(135deg, #FFFFFF 0%, #FEFCF7 100%)',
    },
    
    // Soft overlays and borders
    overlay: {
      light: 'rgba(0, 128, 128, 0.08)',
      medium: 'rgba(54, 69, 79, 0.1)',
      dark: 'rgba(54, 69, 79, 0.15)',
    },
    
    // Border colors
    border: {
      light: '#E8E5E0',
      medium: '#D4D1CC',
      accent: '#008080',
    }
  },
  
  fonts: {
    heading: '"Playfair Display", "Lora", Georgia, serif', // Elegant serif as specified
    subheading: '"Playfair Display", "Lora", Georgia, serif', // Consistent serif for headings
    body: '"Lato", "Montserrat", "Inter", Arial, sans-serif', // Clean sans-serif as specified
    ui: '"Lato", "Montserrat", "Inter", Arial, sans-serif', // UI elements use same clean font
    mono: '"JetBrains Mono", "Courier New", monospace',
  },
  
  fontSizes: {
    xs: '0.75rem',    // 12px
    sm: '0.875rem',   // 14px
    md: '1rem',       // 16px
    lg: '1.125rem',   // 18px
    xl: '1.25rem',    // 20px
    '2xl': '1.5rem',  // 24px
    '3xl': '1.875rem',// 30px
    '4xl': '2.25rem', // 36px
    '5xl': '3rem',    // 48px
    '6xl': '3.75rem', // 60px
  },
  
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700,
  },
  
  spacing: {
    '0': '0',
    '1': '0.25rem',    // 4px
    '2': '0.5rem',     // 8px
    '3': '0.75rem',    // 12px
    '4': '1rem',       // 16px
    '5': '1.5rem',     // 24px
    '6': '2rem',       // 32px
    '7': '2.5rem',     // 40px
    '8': '3rem',       // 48px
    '9': '4rem',       // 64px
    '10': '6rem',      // 96px
  },
  
  breakpoints: {
    xs: '320px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1400px',
  },
  
  borderRadius: {
    none: '0',
    sm: '0.25rem',    // 4px
    md: '0.5rem',     // 8px 
    lg: '1rem',       // 16px
    xl: '2rem',       // 32px
    full: '50%',
    pill: '9999px',
  },
  
  shadows: {
    none: 'none',
    sm: '0 1px 3px rgba(44, 44, 44, 0.12), 0 1px 2px rgba(44, 44, 44, 0.08)',
    md: '0 4px 6px rgba(44, 44, 44, 0.1), 0 2px 4px rgba(44, 44, 44, 0.06)',
    lg: '0 10px 15px rgba(44, 44, 44, 0.08), 0 4px 6px rgba(44, 44, 44, 0.04)',
    xl: '0 20px 25px rgba(44, 44, 44, 0.06), 0 10px 10px rgba(44, 44, 44, 0.04)',
    warm: '0 4px 12px rgba(218, 165, 32, 0.15)',
    accent: '0 2px 8px rgba(32, 178, 170, 0.2)',
  },
  
  transitions: {
    quick: '0.15s ease-in-out',
    default: '0.3s ease-in-out',
    slow: '0.5s ease-in-out',
    extraSlow: '1s ease-in-out',
    bounce: '0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55)',
    psychedelic: '0.5s cubic-bezier(0.23, 1, 0.32, 1)',
  },
  
  // Z-index layers
  zIndex: {
    hidden: -1,
    base: 0,
    raised: 1,
    dropdown: 10,
    sticky: 100,
    overlay: 200,
    modal: 300,
    popover: 400,
    tooltip: 500,
  }
};

export default theme;
export { theme };